// extracted by mini-css-extract-plugin
module.exports = {"SearchButton":"SearchButton_SearchButton__RnCR6","Icon":"SearchButton_Icon__IhWOJ","Label":"SearchButton_Label__8KSIp"};